import { LegacyDataSource } from "@kaggle/sdk";
import { ModalActionKey } from "../../../actions/ActionKeys";
import { ModalAction } from "../../../actions/modal";

export interface State {
  kernelId?: number;
  versionId?: number;
  runId?: number;
  kernelUrl?: string;
  code?: string;
  rulesAcceptance?: {
    competitionId: number;
    datasource: LegacyDataSource;
  };
}

export const metadata = (state: State = {}, action: ModalAction): State => {
  switch (action.type) {
    case ModalActionKey.SET_MODAL_METADATA:
      return {
        ...action.payload,
      };
    default:
      return state;
  }
};
